import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { getPreferences } from '../firebase/dataHandler';

export default function PremiumFeatureLock({ children, title = "Premium Feature", description = "Unlock advanced analytics, export options, and insights with a Premium subscription.", features = [] }) {
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getPreferences().then(prefs => {
      setIsPremium(prefs.isPremium === true);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <Box sx={{ p: 2, textAlign: 'center' }}><Typography sx={{ color: 'var(--text-muted)' }}>Checking access...</Typography></Box>;
  }

  if (isPremium) {
    return children;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4, height: '100%', minHeight: '50vh' }}>
      <Box sx={{ background: 'var(--bg-elevated)', p: 4, borderRadius: 4, border: '1px solid var(--border-subtle)', textAlign: 'center', maxWidth: '400px', boxShadow: '0 8px 32px rgba(0,0,0,0.5)' }}>
        <Box sx={{ background: 'rgba(255,138,101,0.1)', p: 1.5, borderRadius: '50%', display: 'inline-flex', mb: 2 }}>
          <LockOutlined sx={{ color: '#ff8a65', fontSize: 32 }} />
        </Box>
        <Typography sx={{ color: 'var(--text-primary)', fontWeight: 700, fontSize: 18, mb: 1, fontFamily: 'Inter' }}>
          {title}
        </Typography>
        <Typography sx={{ color: 'var(--text-secondary)', fontSize: 13, mb: 3, fontFamily: 'Inter' }}>
          {description}
        </Typography>
        
        {features && features.length > 0 && (
          <Box sx={{ textAlign: 'left', mb: 4, background: 'var(--bg-base)', p: 2, borderRadius: 2, border: '1px solid var(--border-subtle)' }}>
            {features.map((feature, i) => (
              <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', mb: 1, gap: 1 }}>
                <Box sx={{ color: '#ff8a65', mt: '2px' }}>✓</Box>
                <Typography sx={{ color: 'var(--text-primary)', fontSize: 13 }}>{feature}</Typography>
              </Box>
            ))}
          </Box>
        )}

        <Button 
          onClick={() => navigate('/subscription')}
          variant="contained" 
          fullWidth
          sx={{
            background: 'linear-gradient(135deg, #ff8a65 0%, #ff4d6d 100%)',
            color: '#fff',
            borderRadius: 50,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: '0 4px 14px rgba(255,138,101,0.4)',
            '&:hover': { background: 'linear-gradient(135deg, #ff7043 0%, #ff1744 100%)' }
          }}
        >
          Upgrade Now
        </Button>
      </Box>
    </Box>
  );
}
